/// <reference path="../types.d.ts"

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  api,
  appServiceLines,
  cmxDateTime,
  commonEnums,
  HttpMethods
} from '../index';
import { CreateCase } from './action-types';
import { toggleChargeableCase } from './code-bench.actions';
import { fetchDictionaryRows } from './dictionary-utilities';
import { amplifyFeedback } from './ui.actions';

export const navigateCreateCase = createAsyncThunk<
  any[],
  CMxAPI.CaseRunV2,
  { rejectValue: CMxCommonApp.CMxError }
>(CreateCase.NAVIGATE_CREATE_CASE, async (_caseRun, _thunkAPI) => {
  return [];
});

export const fetchNotesSpecialty = createAsyncThunk<
  Accelerate.DictionaryRowData<CMxCommonApp.NotesSpecialtyRow>,
  string
>(CreateCase.FETCH_NOTES_SPECIALTY, async (tenantId, _thunkAPI) => {
  const effectiveDate = cmxDateTime.format(
    new Date(),
    cmxDateTime.FORMATS.DATE
  );
  const searchParams = new URLSearchParams({
    tenantId: tenantId,
    effectiveDate: effectiveDate,
    dictionaryName: 'Note Specialty',
    columnName: 'Key'
  });
  return fetchDictionaryRows<CMxCommonApp.NotesSpecialtyRow>(searchParams);
});

export const submitCreateCase = createAsyncThunk<
  AmplifyAPI.ProcessInstance,
  { createCase: CMxCommonApp.CreateCase; activeCaseRun: CMxAPI.CaseRun }
>(
  CreateCase.SUBMIT_CREATE_CASE,
  async ({ createCase, activeCaseRun }, { dispatch }) => {
    let response;
    const serviceLineConfig = appServiceLines.determineServiceLineConfig({
      name: activeCaseRun.service_line,
      caseIdentifier: `${activeCaseRun.case_uid || activeCaseRun.case_id}`
    });
    try {
      response = await api.requestJSON<AmplifyAPI.ProcessInstance>(
        `/coding-api/processinstance/${serviceLineConfig.amplifyPath}/${activeCaseRun.process_instance_guid}/createcase/v1`,
        {
          method: HttpMethods.POST,
          body: JSON.stringify({
            notes_specialty: createCase.notesSpecialty,
            date_of_service: createCase.dateOfService,
            alternate_visit_id: createCase.alternate_visit_id,
            comments: createCase.comments
          })
        }
      );

      // need to remove this once case-automate does this work.
      dispatch(
        toggleChargeableCase({
          serviceLine: response?.serviceLine,
          processInstanceGuid: response?.guid.uuid,
          isChargeable: true
        }) as any
      );

      dispatch(
        amplifyFeedback({
          message: `The case has been created successfully.`,
          meta: commonEnums.FeedbackMeta.SUCCESS,
          dismissable: true
        })
      );
    } catch (error) {
      dispatch(
        amplifyFeedback({
          message: 'There was an error creating this case',
          meta: commonEnums.FeedbackMeta.ERROR,
          dismissable: true
        })
      );
      throw error;
    }
    return response;
  }
);
